<!-- prettier-ignore -->
<h2 mat-dialog-title i18n="@@user.accessRequestDialog.title">An user requests access</h2>

<mat-dialog-content>
  <!-- prettier-ignore -->
  <p i18n="@@user.accessRequestDialog.intro">The user <strong>{{request.user.email}}</strong> is requesting access to your data as administrator</p>

  <p>
    <!-- prettier-ignore -->
    <span i18n="@@user.accessRequestDialog.detailsAdmin">This user will have full access (read and write) to all your devices</span>
    @if (userStore.user$().canViewPlaces()) {
    <!-- prettier-ignore -->
    &nbsp;<span i18n="@@user.accessRequestDialog.andPlaces">and places</span>
    }
  </p>
  <!-- prettier-ignore -->
  <p i18n="@@user.accessRequestDialog.askMessage">Do you want to grant access to this user ?</p>

  @if (statusMessage()) {
  <div class="message-wrapper {{ statusType() }}">
    <span class="message">{{ statusMessage() }}</span>
    @if (statusType() === "loading") {
    <div class="loader"></div>
    }
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- prettier-ignore -->
  <button
  mat-button
  color="request-deny"
  i18n="@@user.accessRequestDialog.denyButton"
  [disabled]="userStore.denyingAccessRequest$() || userStore.acceptingAccessRequest$()"
  (click)="denyRequest()"
  >Deny</button>
  <!-- prettier-ignore -->
  <button
  mat-flat-button
  color="primary"
  i18n="@@user.accessRequestDialog.acceptButton"
  [disabled]="userStore.denyingAccessRequest$() || userStore.acceptingAccessRequest$()"
  (click)="allowRequest()"
  >Allow</button>
</mat-dialog-actions>
